import { BaseModel } from '../models/Base/BaseInterface';

/**
* Converts a set of BaseModels to an enum for radio cards.
* @param {BaseModel[]} obj
*/
export function enumConvert(obj: BaseModel[]) : {} {
  return obj.reduce((acc, curr) => {
    return Object.assign(acc, { [curr.key]: curr.apiValue });
  }, {});
}
